// src/api/features/activity-logs/api.ts

import { request } from "@/api/client";
import { API_PREFIX } from "@/api/constants";
import type {
  ActivityLogListQuery,
  PaginatedActivityLogs,
  PaginatedUserSessions,
} from "./types";

type ApiEnvelope<T> = { ok: boolean; message?: string; data: T };

function unwrap<T>(res: any): T {
  if (res && typeof res === "object" && "data" in res) {
    return (res as ApiEnvelope<T>).data;
  }
  return res as T;
}

function qs(params: Record<string, unknown>): string {
  const u = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v === undefined || v === null || v === "") continue;
    u.set(k, String(v));
  }
  const s = u.toString();
  return s ? `?${s}` : "";
}

const BASE = `${API_PREFIX}/admin/activity-logs`;

export async function adminListActivityLogs(
  query: ActivityLogListQuery = {}
): Promise<PaginatedActivityLogs> {
  const res = await request<any>({ method: "GET", url: `${BASE}${qs(query)}` });
  return unwrap<PaginatedActivityLogs>(res);
}

export async function adminListUserActivitySessions(
  userId: number,
  page = 1,
  limit = 50
): Promise<PaginatedUserSessions> {
  const res = await request<any>({
    method: "GET",
    url: `${BASE}/sessions${qs({ userId, page, limit })}`,
  });
  return unwrap<PaginatedUserSessions>(res);
}
